<template>
  <div class="formAuther-container">
    <!-- 第一作者 -->
    <FormItem class="form-item" label="第一作者" :label-width="80">
      <div class="auther-box">
        <div class="left">
          <FormItem style="width: 100%" prop="firstAuther">
            <Input
              placeholder="请输入第一作者"
              v-model.trim="formValidate.firstAuther"
              clearable
              @input="firstInput"
              @on-focus="handleFocus"
              @on-blur="blurAuther"
              @on-clear="clearFirst"
            />
            <span class="xing">*</span>
          </FormItem>
        </div>
        <div class="right">
          <FormItem style="width: 100%" prop="englishFirstAuthor">
            <Input
              placeholder="请输入第一作者英文名"
              v-model="formValidate.englishFirstAuthor"
            />
          </FormItem>
        </div>
      </div>
      <div class="auther-box" style="margin-top: 39px">
        <FormItem
          style="width: 270px; margin-right: 15px"
          prop="firstUnitId"
          v-if="firstUnitSelect"
        >
          <Select
            style="width: 100%"
            :disabled="
              selectLoding ||
              formValidate.firstAuther === null ||
              formValidate.firstAuther === ''
            "
            v-model="formValidate.firstUnitId"
            :label-in-value="true"
            @on-select="firsUnitSelectMet"
          >
            <OptionGroup label="现工作单位/院校" v-if="firstUnitObj.orgId">
              <Option
                :value="firstUnitObj.orgId"
                :label="firstUnitObj.orgName"
                >{{ firstUnitObj.orgName }}</Option
              >
            </OptionGroup>
            <OptionGroup
              label="原工作单位/院校"
              v-if="firstUnitObj.originalUnits"
            >
              <Option
                v-for="item in firstUnitObj.originalUnits"
                :key="item.id"
                :value="item.id"
                :label="item.unitName"
                >{{ item.unitName }}</Option
              >
            </OptionGroup>
            <Option :value="'null'" :label="'其他'">其他</Option>
          </Select>
        </FormItem>
        <FormItem
          style="flex: 1"
          prop="firstUnit"
          v-if="firstUnitInput"
          :rules="[
            { required: true, message: '作者单位不能为空', trigger: 'blur' },
            { validator: validateUnit, trigger: 'blur' },
          ]"
        >
          <Input
            style="width: 80%"
            placeholder="请输入作者单位"
            v-model.trim="formValidate.firstUnit"
          />
        </FormItem>
      </div>
      <ul class="select-list" v-if="showSelect && firstAutherOption.length > 0">
        <li
          :class="[
            'select-item',
            v.id === formValidate.firstAuthorId ? 'acitve-select' : '',
          ]"
          v-for="v in firstAutherOption"
          :key="v.id"
          @click="echoAuther(v)"
        >
          <span style="margin-right: 5px">{{ v.realname }}</span>
          <span style="float: right; color: #ccc">{{ v.mobile }}</span>
        </li>
        <li class="select-item" @click="editAuther">都不是，直接添加</li>
      </ul>
      <ul
        class="select-list"
        v-if="showSelect && firstAutherOption.length === 0"
      >
        <li class="select-item" @click="editAuther">未找到该学者，直接添加</li>
      </ul>
    </FormItem>
    <!-- 其他作者 -->
    <div v-for="(v, i) in formValidate.articleAuthorList" :key="i">
      <FormItem class="form-item" label="其他作者" :label-width="80">
        <div class="auther-box">
          <div class="left">
            <FormItem style="width: 100%">
              <Input
                placeholder="请输入其他作者"
                v-model.trim="v.authorName"
                :disabled="!formValidate.firstAuther"
                clearable
                @input="otherInput(v)"
                @on-focus="handleFocus1(v, i)"
                @on-blur="blurAuther1(v, i)"
                @on-clear="clearOther(v, i)"
              />
              <span class="xing"></span>
            </FormItem>
          </div>
          <!-- <div class="right" v-if="isPaper"> -->
          <div class="right">
            <FormItem
              style="width: 100%"
              :prop="'articleAuthorList.' + i + '.englishAuthorName'"
              :rules="{
                type: 'string',
                pattern:
                  /^[^\u4e00-\u9fa5\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]+$/,
                message: '请勿填写中文',
                trigger: 'blur',
              }"
            >
              <Input
                :disabled="!formValidate.firstAuther"
                placeholder="请输入其他作者英文名"
                v-model="v.englishAuthorName"
              />
            </FormItem>
          </div>
          <div
            class="plus"
            @click="addAuther(v)"
            v-if="formValidate.articleAuthorList.length - 1 === i"
          >
            +
          </div>
        </div>
        <div class="auther-box" style="margin-top: 39px">
          <FormItem
            style="width: 270px; margin-right: 15px"
            v-if="v.unitSelect"
            :prop="'articleAuthorList.' + i + '.authorUnitId'"
            :rules="[
              {
                validator: (rule, value, callback) =>
                  validateOtherUnit(v, rule, value, callback),
                trigger: 'change',
              },
            ]"
          >
            <Select
              style="width: 100%"
              v-model="v.authorUnitId"
              :disabled="
                !formValidate.firstAuther ||
                v.authorName === null ||
                v.authorName === ''
              "
              :label-in-value="true"
              @on-select="
                (query) => {
                  otherUnitSelectMet(query, v);
                }
              "
            >
              <OptionGroup label="现工作单位/院校" v-if="v.otherUnitObj.orgId">
                <Option
                  :value="v.otherUnitObj.orgId"
                  :label="v.otherUnitObj.orgName"
                  >{{ v.otherUnitObj.orgName }}</Option
                >
              </OptionGroup>
              <OptionGroup
                label="原工作单位/院校"
                v-if="v.otherUnitObj.originalUnits"
              >
                <Option
                  v-for="item in v.otherUnitObj.originalUnits"
                  :key="item.id"
                  :value="item.id"
                  :label="item.unitName"
                  >{{ item.unitName }}</Option
                >
              </OptionGroup>
              <Option :value="'null'" :label="'其他'">其他</Option>
            </Select>
          </FormItem>
          <FormItem
            style="flex: 1"
            v-if="v.unitInput"
            :prop="'articleAuthorList.' + i + '.authorUnit'"
            :rules="[
              {
                validator: (rule, value, callback) =>
                  validateOtherUnitInput(v, rule, value, callback),
                trigger: 'blur',
              },
            ]"
          >
            <Input
              style="width: 80%"
              placeholder="请输入作者单位"
              v-model.trim="v.authorUnit"
            />
          </FormItem>
        </div>
        <ul
          class="select-list"
          v-if="v.showSelect1 && otherAutherOption.length > 0"
        >
          <li
            :class="[
              'select-item',
              item.id === v.authorId ? 'acitve-select' : '',
            ]"
            v-for="item in otherAutherOption"
            :key="item.id"
            @click="echoAuther1(v, item, i)"
          >
            <span style="margin-right: 5px">{{ item.realname }}</span>
            <span style="float: right; color: #ccc">{{ item.mobile }}</span>
          </li>
          <li class="select-item" @click="editAuther1(v, i)">
            都不是，直接添加
          </li>
        </ul>
        <ul
          class="select-list"
          v-if="v.showSelect1 && otherAutherOption.length === 0"
        >
          <li class="select-item" @click="editAuther1(v, i)">
            未找到该学者，直接添加
          </li>
        </ul>
      </FormItem>
    </div>
    <!-- 通讯作者 -->
    <FormItem class="form-item" label="通讯作者" :label-width="80">
      <div class="auther-box">
        <div class="left">
          <FormItem style="width: 100%">
            <Input
              placeholder="请输入通讯作者"
              v-model.trim="formValidate.communicationAuthor"
              clearable
              @input="communicationInput"
              @on-focus="handleFocus2"
              @on-blur="blurAuther2"
              @on-clear="clearCommunication"
            />
            <span class="xing"></span>
          </FormItem>
        </div>
        <!-- <div class="right" v-if="isPaper"> -->
        <div class="right">
          <FormItem style="width: 100%" prop="englishCommunicationAuthor">
            <Input
              placeholder="请输入通讯作者英文名"
              v-model="formValidate.englishCommunicationAuthor"
            />
          </FormItem>
        </div>
      </div>
      <div class="auther-box" style="margin-top: 39px">
        <FormItem
          style="width: 270px; margin-right: 15px"
          v-if="comUnitSelect"
          ref="communicationAuthorUnitIdItem"
          prop="communicationAuthorUnitId"
          :rules="[{ validator: validateComUnit, trigger: 'change' }]"
        >
          <Select
            style="width: 100%"
            :disabled="
              selectLoding ||
              formValidate.communicationAuthor === null ||
              formValidate.communicationAuthor === '' ||
              formValidate.communicationAuthor === undefined
            "
            v-model="formValidate.communicationAuthorUnitId"
            :label-in-value="true"
            @on-select="comUnitSelectMet"
          >
            <OptionGroup label="现工作单位/院校" v-if="comUnitObj.orgId">
              <Option :value="comUnitObj.orgId" :label="comUnitObj.orgName">{{
                comUnitObj.orgName
              }}</Option>
            </OptionGroup>
            <OptionGroup
              label="原工作单位/院校"
              v-if="comUnitObj.originalUnits"
            >
              <Option
                v-for="item in comUnitObj.originalUnits"
                :key="item.id"
                :value="item.id"
                :label="item.unitName"
                >{{ item.unitName }}</Option
              >
            </OptionGroup>
            <Option :value="'null'" :label="'其他'">其他</Option>
          </Select>
        </FormItem>
        <FormItem
          style="flex: 1"
          prop="communicationAuthorUnit"
          v-if="comUnitInput"
          :rules="[{ validator: validateComUnitInput, trigger: 'blur' }]"
        >
          <Input
            style="width: 80%"
            placeholder="请输入作者单位"
            v-model.trim="formValidate.communicationAuthorUnit"
          />
        </FormItem>
      </div>
      <ul class="select-list" v-if="showSelect2 && comAutherOption.length > 0">
        <li
          :class="[
            'select-item',
            v.id === formValidate.communicationAuthorId ? 'acitve-select' : '',
          ]"
          v-for="v in comAutherOption"
          :key="v.id"
          @click="echoAuther2(v)"
        >
          <span style="margin-right: 5px">{{ v.realname }}</span>
          <span style="float: right; color: #ccc">{{ v.mobile }}</span>
        </li>
        <li class="select-item" @click="editAuther2">都不是，直接添加</li>
      </ul>
      <ul
        class="select-list"
        v-if="showSelect2 && comAutherOption.length === 0"
      >
        <li class="select-item" @click="editAuther2">未找到该学者，直接添加</li>
      </ul>
    </FormItem>
  </div>
</template>

<script>
export default {
  props: {
    formValidate: {
      type: Object,
      default: () => {},
    },
    isPaper: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      FAuthorName: "", // 第一作者名备用
      showSelect: false, // 第一作者下拉框控制
      firstAutherOption: [], // 第一作者选择列表
      firstUnitObj: {},
      firstUnitSelect: true,
      firstUnitInput: false,

      CAuthorName: "", // 通讯作者名备用
      showSelect2: false, // 通讯作者下拉框控制
      comAutherOption: [], // 通讯选择列表
      comUnitObj: {},
      comUnitSelect: true,
      comUnitInput: false,

      AAuthorName: [], // 其他作者名备用数组
      otherAutherOption: [], // 其他作者列表

      selectLoding: false, // 单位下拉选项框loding
    };
  },
  watch: {
    "formValidate.firstAuthorId": {
      handler(newVal, oldVal) {
        if (newVal === undefined) {
          this.firstUnitSelect = false;
          return;
        }
        if (newVal === "" || newVal === oldVal || newVal === null) return;
        this.getFirstAutherUnit(
          newVal,
          "firstUnitObj",
          "firstUnitId",
          "firstUnit"
        );
      },
      deep: true,
    },
    "formValidate.communicationAuthorId": {
      handler(newVal, oldVal) {
        if (newVal === undefined) {
          this.comUnitSelect = this.formValidate.communicationAuthor === "";
          return;
        }
        if (
          newVal === "" ||
          newVal === oldVal ||
          newVal === null 
        ) {
          return
        }
        this.getFirstAutherUnit(
          newVal,
          "comUnitObj",
          "communicationAuthorUnitId",
          "communicationAuthorUnit"
        );
      },
      deep: true,
    },
    "formValidate.articleAuthorList": {
      handler(newVal, oldVal) {
        newVal.forEach(async (item, index) => {
          if (item.authorId === undefined) return;
          if (!oldVal[index]) {
            const resp = await this.$apis.userServe.getUnitList({
              userId: item.authorId,
            });
            this.formValidate.articleAuthorList[index].otherUnitObj =
              resp.content;
            return;
          } else if (
            item.authorId !== "" &&
            item.authorId !== oldVal[index].authorId &&
            item.authorId !== null
          ) {
            const resp = await this.$apis.userServe.getUnitList({
              userId: item.authorId,
            });
            this.formValidate.articleAuthorList[index].otherUnitObj =
              resp.content;
          }
        });
      },
      deep: true,
    },
    "formValidate.firstUnitId": {
      // 规避 nawVal可能等于null值 而不是字符串null
      handler(newVal) {
        if (newVal === "null") {
          this.firstUnitInput = true;
        }
      },
      deep: true,
    },
    "formValidate.communicationAuthorUnitId": {
      // 规避 nawVal可能等于null值 而不是字符串null
      handler(newVal) {
        if (
          newVal === "null" &&
          this.formValidate.communicationAuthor !== undefined
        ) {
          this.comUnitInput = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    /**
     * 第一作者
     */
    // 输入时触发
    firstInput() {
      if (this.formValidate.firstAuther === "") {
        this.showSelect = false;
      } else {
        this.showSelect = true;
        this.$preventFun.Debounce(() => {
          this.findAuthorInfoByNameAndCompany(
            this.formValidate.firstAuther,
            "firstAutherOption"
          );
        })();
      }
    },
    // 获取焦点触发
    handleFocus() {
      this.FAuthorName = this.formValidate.firstAuther; // 获取备用名防止取消恢复显示
      if (this.formValidate.firstAuther === "") return;
      this.$preventFun.Debounce(() => {
        this.findAuthorInfoByNameAndCompany(
          this.formValidate.firstAuther,
          "firstAutherOption"
        );
      })();
      this.showSelect = true;
    },
    // 失去焦点触发
    blurAuther() {
      setTimeout(() => {
        this.formValidate.firstAuther = this.FAuthorName; // 取消选择恢复备用显示
        this.showSelect = false;
      }, 200);
    },
    // 点击下拉框选择选项
    echoAuther(item) {
      this.FAuthorName = item.realname;
      this.showSelect = false;
      this.firstUnitSelect = true;
      this.firstUnitInput = false;
      this.$emit(
        "autherInfo",
        this.formValidate.firstAuther,
        item.id,
        null,
        null
      ); // 参数 名,用户id,单位名,单位ID
    },
    //下拉框选择自行填入
    editAuther() {
      this.FAuthorName = this.formValidate.firstAuther;
      this.showSelect = false;
      this.firstUnitSelect = false;
      this.firstUnitInput = true;
      this.$emit("autherInfo", this.formValidate.firstAuther, null, null, null); // 参数 名,用户id,单位名,单位ID
    },
    // 清空列表
    clearFirst() {
      this.FAuthorName = "";
      this.firstUnitObj = {};
      this.showSelect = false;
      this.firstUnitSelect = true;
      this.firstUnitInput = false;
      this.$emit("autherInfo", "", "", null, null); // 参数 名,用户id,单位名,单位ID
    },
    // 选择单位下拉框选项
    firsUnitSelectMet(query) {
      if (query.label !== "其他" && query.value !== "") {
        this.firstUnitInput = false;
        this.formValidate.firstUnit = query.label;
      } else {
        this.formValidate.firstUnit = "";
        this.firstUnitInput = true;
      }
    },
    validateUnit(rule, value, callback) {
      if (
        (this.firstUnitObj.orgName && this.firstUnitObj.orgName === value) ||
        (this.firstUnitObj.originalUnits &&
          this.firstUnitObj.originalUnits.some(
            (item) => item.unitName === value
          ))
      ) {
        return callback(new Error("该单位已存在,请直接选择"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },

    /**
     * 其他作者
     */
    // 添加其他作者
    addAuther(v) {
      if (v.authorName === "") return;
      this.formValidate.articleAuthorList.push({
        authorName: "",
        authorId: "",
        authorUnit: "",
        authorUnitId: "",
        englishAuthorName: "",
        otherUnitObj: {},
        showSelect1: false,
        unitSelect: true,
        unitInput: false,
      });
    },
    // 输入时触发
    otherInput(v) {
      if (v.authorName === "") {
        v.showSelect1 = false;
      } else {
        v.showSelect1 = true;
        this.$preventFun.Debounce(() => {
          this.findAuthorInfoByNameAndCompany(
            v.authorName,
            "otherAutherOption"
          );
        })();
      }
    },
    // 获取焦点触发
    handleFocus1(v, index) {
      this.AAuthorName[index] = v.authorName; // 获取备用名防止取消恢复显示
      if (v.authorName === "") return;
      this.$preventFun.Debounce(() => {
        this.findAuthorInfoByNameAndCompany(v.authorName, "otherAutherOption");
      })();
      this.formValidate.articleAuthorList.forEach((item) => {
        return (item.showSelect1 = false);
      });
      v.showSelect1 = true;
    },
    // 失去焦点触发
    blurAuther1(v, index) {
      setTimeout(() => {
        v.authorName = this.AAuthorName[index]; // 取消选择恢复备用显示
        v.showSelect1 = false;
      }, 200);
    },
    // 点击下拉框选择选项
    async echoAuther1(v, item, index) {
      this.AAuthorName[index] = item.realname;
      v.authorName = item.realname;
      v.authorId = item.id;
      v.showSelect1 = false;
      v.unitSelect = true;
      v.unitInput = false;
      if (item.id !== "") {
        const resp = await this.$apis.userServe.getUnitList({
          userId: item.id,
        });
        v.otherUnitObj = resp.content;
        v.authorUnitId = resp.content.orgId;
        v.authorUnit = resp.content.orgName;
      }
    },
    //下拉框选择自行填入
    editAuther1(v, index) {
      this.AAuthorName[index] = v.authorName;
      v.authorId = null;
      v.authorUnit = null;
      v.authorUnitId = null;
      v.showSelect1 = false;
      v.unitSelect = false;
      v.unitInput = true;
    },
    // 清空列表
    clearOther(v, index) {
      this.AAuthorName[index] = "";
      v.authorName = "";
      v.authorId = null;
      v.authorUnit = "";
      v.authorUnitId = null;
      v.showSelect1 = false;
      v.unitSelect = true;
      v.unitInput = false;
      v.otherUnitObj = {};
    },
    // 其他作者单位下拉框选择选项触发
    otherUnitSelectMet(query, v) {
      if (query.label !== "其他" && query.value !== "") {
        v.unitInput = false;
        v.authorUnit = query.label;
      } else {
        v.authorUnit = "";
        v.unitInput = true;
      }
    },
    validateOtherUnit(query, rule, value, callback) {
      // 其他作者单位下拉框校验  填写是其他作者才开始校验 不填不校验
      if (
        query.authorName !== "" &&
        query.authorName !== null &&
        (value === "" || value === null)
      ) {
        return callback(new Error("作者单位不能为空"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    validateOtherUnitInput(query, rule, value, callback) {
      // 其他作者单位输入框校验
      if (
        (query.otherUnitObj.orgName && query.otherUnitObj.orgName === value) ||
        (query.otherUnitObj.originalUnits &&
          query.otherUnitObj.originalUnits.some(
            (item) => item.unitName === value
          ))
      ) {
        return callback(new Error("该单位已存在,请直接选择"));
      } else if (
        query.authorName !== "" &&
        query.authorName !== null &&
        (value === "" || value === null)
      ) {
        return callback(new Error("作者单位不能为空"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },

    /**
     * 通讯作者
     */
    // 输入时触发
    communicationInput() {
      if (this.formValidate.communicationAuthor === "") {
        this.showSelect2 = false;
      } else {
        this.showSelect2 = true;
        this.$preventFun.Debounce(() => {
          this.findAuthorInfoByNameAndCompany(
            this.formValidate.communicationAuthor,
            "comAutherOption"
          );
        })();
      }
    },
    // 获得焦点触发
    handleFocus2() {
      this.CAuthorName = this.formValidate.communicationAuthor;
      if (this.formValidate.communicationAuthor === "") return;
      this.$preventFun.Debounce(() => {
        this.findAuthorInfoByNameAndCompany(
          this.formValidate.communicationAuthor,
          "comAutherOption"
        );
      })();
      this.showSelect2 = true;
    },
    // 失去焦点触发
    blurAuther2() {
      setTimeout(() => {
        this.formValidate.communicationAuthor = this.CAuthorName;
        this.showSelect2 = false;
      }, 200);
    },
    // 点击下拉框选择选项
    echoAuther2(item) {
      this.CAuthorName = item.realname;
      this.showSelect2 = false;
      this.comUnitSelect = true;
      this.comUnitInput = false;
      this.$emit("autherInfo2", item.realname, item.id, null, null); // 参数 名,用户id,单位名,单位ID
    },
    //下拉框选择自行填入
    editAuther2() {
      this.CAuthorName = this.formValidate.communicationAuthor;
      this.showSelect2 = false;
      this.comUnitSelect = false;
      this.comUnitInput = true;
      this.$emit(
        "autherInfo2",
        this.formValidate.communicationAuthor,
        null,
        null,
        null
      );
    },
    // 清空列表
    clearCommunication() {
      this.CAuthorName = "";
      this.comUnitObj = {};
      this.showSelect2 = false;
      this.comUnitSelect = true;
      this.comUnitInput = false;
      this.$emit("autherInfo2", null, null, null, null);
    },
    // 选择单位下拉框选项
    comUnitSelectMet(query) {
      if (query.label !== "其他" && query.value !== "") {
        this.comUnitInput = false;
        this.formValidate.communicationAuthorUnit = query.label;
      } else {
        this.formValidate.communicationAuthorUnit = "";
        this.comUnitInput = true;
      }
    },
    validateComUnit(rule, value, callback) {
      // 通讯作者单位下拉框校验  填写是通讯作者才开始校验 不填不校验
      if (
        this.formValidate.communicationAuthor !== "" &&
        this.formValidate.communicationAuthor !== null &&
        (value === "" || value === null)
      ) {
        return callback(new Error("作者单位不能为空"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },
    validateComUnitInput(rule, value, callback) {
      // 通讯作者单位输入框校验
      if (
        (this.comUnitObj.orgName && this.comUnitObj.orgName === value) ||
        (this.comUnitObj.originalUnits &&
          this.comUnitObj.originalUnits.some((item) => item.unitName === value))
      ) {
        return callback(new Error("该单位已存在,请直接选择"));
      } else if (
        this.formValidate.communicationAuthor !== "" &&
        this.formValidate.communicationAuthor !== null &&
        (value === "" || value === null)
      ) {
        return callback(new Error("作者单位不能为空"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    },

    // 查询文章发布作者
    async findAuthorInfoByNameAndCompany(query, list) {
      const resp = await this.$apis.userServe.findAuthorInfoByNameAndCompany({
        name: query,
      });
      this[list] = [...resp.data.list];
    },
    // 查询作者单位
    async getFirstAutherUnit(userId, obj, unitId, unitName) {
      if (userId !== "") {
        this.selectLoding = true;
        const resp = await this.$apis.userServe.getUnitList({ userId });
        this[obj] = resp.content;
        this.formValidate[unitId] =
          this.formValidate[unitId] === "null" ? "null" : resp.content.orgId;
        this.formValidate[unitName] = this.formValidate[unitName]
          ? this.formValidate[unitName]
          : resp.content.orgName;
        this.selectLoding = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ivu-input[disabled],
fieldset[disabled] .ivu-input {
  opacity: 0.7;
}
.ivu-input-wrapper ::v-deep input {
  border: none;
  background-color: #fff;
  // height: 38px;
}
.ivu-input-wrapper ::v-deep input::-webkit-input-placeholder,
.ivu-input-wrapper ::v-deep textarea::-webkit-input-placeholder {
  color: #999;
}
.form-item {
  padding-bottom: 25px;
  width: 100%;
  color: #999;
  border-bottom: 1px solid #dcdcdc;
  &::v-deep .ivu-form-item-label {
    min-width: 80px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .auther-box {
    display: flex;
    align-items: center;
    &::v-deep .ivu-form-item-content {
      display: flex;
      align-items: center;
    }
  }
  .plus {
    padding: 0 6px;
    width: 30px;
    height: 30px;
    border: 1px solid #dcdcdc;
    border-radius: 50%;
    line-height: 25px;
    font-size: 24px;
    cursor: pointer;
  }
  .icon-pager {
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    a {
      display: inline-block;
      width: 50px;
      text-align: center;
      user-select: none;
      cursor: pointer;
      color: #999;
      &:active {
        color: #dcdcdc;
      }
    }
  }
  .select-list {
    overflow: auto;
    position: absolute;
    left: 0;
    top: 35px;
    margin: 5px 0;
    padding: 5px 0;
    min-width: 240px;
    max-height: 200px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
    z-index: 999;

    .select-item,
    .none {
      margin: 0;
      line-height: normal;
      padding: 7px 16px;
      clear: both;
      color: #515a6e;
      font-size: 14px !important;
      white-space: nowrap;
      list-style: none;
      cursor: pointer;
      transition: background 0.2s ease-in-out;
    }
    .acitve-select {
      color: #2d8cf0;
    }
  }
  .xing {
    width: 30px;
    color: red;
    text-align: center;
  }
  .left,
  .right {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .left {
    border-right: 1px solid #dcdcdc;
    width: 270px;
  }
  .right {
    margin-left: 10px;
    flex: 1;
  }
}
</style>
